import React from 'react';
import LocalizedLink from '../LocalizedLink';
import CartStore from '../../stores/Cart';
import { inject, observer } from 'mobx-react';
import { HeartIcon } from '@heroicons/react/24/outline';
import Translate from '../Translate/Translate';

interface Props {
  cart?: CartStore;
  closeMobileMenu?: () => void;
}

@inject('cart')
@observer
export default class FavouriteButton extends React.Component<Props> {
  render() {
    const { cart, closeMobileMenu } = this.props;
    return (
      <LocalizedLink
        to="/lemmikud"
        onClick={closeMobileMenu}
        className={`flex flex-col items-center justify-center border rounded p-4 lg:p-0 border-solid border-rgrey-light w-full lg:h-10 lg:w-10 ${
          cart.nrOfFavourites > 0
            ? 'border bg-black text-white border-solid border-black fill-white'
            : 'hover:bg-rgrey-light'
        }`}
        ariaLabel="Lemmikud"
        title="Lemmikud"
      >
        <HeartIcon className="h-7 w-7" />
        <p className="lg:hidden uppercase pt-3 lg:pt-0 lg:pr-4 font-axi-bold text-center lg:whitespace-nowrap">
          <Translate component="mobile-menu" keyword="favourites" />
        </p>
      </LocalizedLink>
    );
  }
}
